import OSS from 'ali-oss';
import { v4 as uuidv4 } from 'uuid';
import { api_config } from '@/constants/api';
import { request } from '@/api/request';
import Utils from '@/utils/utils';
let client = null,
  ossBucket = '',
  ossRegion = '',
  file_prefix = '';
const API_URL = api_config.API_URL;
const uidAndTime = `${uuidv4()}-${Date.parse(new Date())}`;
file_prefix = 'static/' + getNowFormatDate() + '/' + uidAndTime + '/input/';
let ext = '';

let curEnv =
  process.env.NODE_ENV === 'development' ||
  process.env.REACT_APP_BUILD_ENV === 'development'
    ? 'dev'
    : 'prod';
if (curEnv === 'dev') {
  ossBucket = 'piccutout-sgp-test';
  ossRegion = 'oss-ap-southeast-1';
} else {
  ossBucket = 'piccutout-sgp-prod';
  ossRegion = 'oss-ap-southeast-1';
}
let cancel = false; // 取消上传控制项
// 阿里云获取授权
const getClientData = async () => {
  try {
    const options = {
      method: 'POST',
    };
    cancel = false;
    let data = await request(API_URL + '/security-token/v3', options);
    file_prefix = data.data.prefix || file_prefix;
    client = new OSS({
      secure: true, // secure: 配合region使用，如果指定了secure为true，则使用HTTPS访问
      accessKeyId: data.data.access_key_id,
      accessKeySecret: data.data.access_key_secret,
      bucket: ossBucket,
      stsToken: data.data.security_token,
      region: ossRegion,
      // 刷新临时访问凭证。
      refreshSTSToken: async () => {
        const refreshToken = await request(API_URL + '/security-token/v3');
        file_prefix = refreshToken.data.prefix || file_prefix;
        return {
          secure: true, // secure: 配合region使用，如果指定了secure为true，则使用HTTPS访问
          accessKeyId: refreshToken.data.access_key_id,
          accessKeySecret: refreshToken.data.access_key_secret,
          bucket: 'piccutout-test',
          stsToken: refreshToken?.data.security_token,
          region: 'oss-accelerate',
        };
      },
    });
    return {
      type: true,
      info: '200',
    };
  } catch (error) {
    return {
      type: false,
      info: '401',
    };
  }
};

// 普通上传
/**
 *
 * @param {*} file 文件
 * @param {string} name 文件名
 * @param callback 上传之后的回调, 进度的回调
 * @param isBatch 是否批量
 */
let _callback = null;
export const ossUploadFile = (file, chunkSize, callback, isBatch = false) => {
  _callback = callback;
  if (file.raw && file.raw.name) {
    ext = file.raw.name.substring(file.raw.name.lastIndexOf('.'));
  } else {
    ext = file.name.substring(file.name.lastIndexOf('.'));
  }
  // 由于需要拿到进度，所有的上传全部分片上传
  multipartUpload(file, chunkSize).then(
    (res) => {
      // eslint-disable-next-line no-unused-expressions
      callback ? callback(res) : '';
    },
    (err) => {
      // eslint-disable-next-line no-unused-expressions
      callback ? callback(err) : '';
    }
  );
  // if (file.size > splitFile.fileSize) {
  //   console.log('开始读md5');
  //   console.time('readMd5');
  //   // 读取md5，用于埋点及分片上传请求
  //   Utils.fileMd5Func(file, splitFile.fileSize).then((md5) => {
  //     console.timeEnd('readMd5');
  //     console.log('fileMd5', md5);
  //     //   fileStore.videoMd5 = md5;
  //   });
  //   // 大于50M分片上传
  //   multipartUpload(file, chunkSize).then(
  //     (res) => {
  //       // eslint-disable-next-line no-unused-expressions
  //       callback ? callback(res) : '';
  //     },
  //     (err) => {
  //       // eslint-disable-next-line no-unused-expressions
  //       callback ? callback(err) : '';
  //     }
  //   );
  // } else {
  //   // 小于50M普通上传
  //   put(file, name).then(
  //     (res) => {
  //       // eslint-disable-next-line no-unused-expressions
  //       callback ? callback(res) : '';
  //     },
  //     (err) => {
  //       // eslint-disable-next-line no-unused-expressions
  //       callback ? callback(err) : '';
  //     }
  //   );
  // }
};

/**
 * 普通上传
 * @param {*} file 文件
 * @param {string} name 文件名
 */
// const put = async (file, name) => {
//   return new Promise(async (resolve, reject) => {
//     const info = await getClientData();
//     if (info && !info.type) {
//       return reject(false);
//     }
//     let filename = name || uuidv4(),
//       filePath = `/${file_prefix}${filename}${ext}`;
//     uploadGa(file);
//     fileUploadRequest();
//     async function fileUploadRequest() {
//       try {
//         const headers = {
//           // 指定Object的访问权限。
//           // 'x-oss-object-acl': 'public-read',
//         };
//         const result = await client.put(
//           `/${filePath}`,
//           file.raw && file.raw.size ? file.raw : file,
//           {
//             headers,
//           }
//         );
//         const res = result.res;
//         if (res?.status === 200) {
//           let uploadFileUrl = res.requestUrls[0];
//           // 上传成功ga
//           let endUpload = Math.round(
//             (new Date().getTime() - beginUpload) / 1000
//           );
//           resolve({
//             uploadFileUrl: uploadFileUrl,
//             uploadFinished: true,
//             type: 'put',
//             gaData: {
//               endUpload: endUpload,
//               gafileExtension: gafileExtension,
//               gafileSize: gafileSize,
//               videoFrame: videoFrame,
//               videoBitRate: videoBitRate,
//             },
//           });
//         }
//       } catch (e) {
//         reject({
//           uploadFinished: false,
//           type: 'put',
//           gaData: {
//             gafileExtension: gafileExtension,
//             gafileSize: gafileSize,
//             videoFrame: videoFrame,
//             videoBitRate: videoBitRate,
//           },
//         });
//       }
//     }
//   });
// };

/**
 * 分片上传
 * @param {*} file 文件
 * @param {number} chunkSize 每个分片大小
 * @param {string} name 文件名
 */
const multipartUpload = async (file, chunkSize) => {
  return new Promise(async (resolve, reject) => {
    const info = await getClientData();
    if (info && !info.type) {
      return reject({
        code: info,
        data: {},
      });
    }
    let fileMd5 = await Utils.fileMd5Func(file);
    let filePath = `/${file_prefix}${fileMd5}${ext}`;
    uploadGa(file);
    uploader();
    async function uploader() {
      const headers = {
        'x-oss-object-acl': 'public-read',
      };
      const options = {
        // 获取分片上传进度、断点和返回值。
        progress: (p, cpt) => {
          if (cancel) {
            client.cancel();
            cancel = false;
          }
          if (p < 1) {
            _callback({
              code: 200,
              data: {
                progress: (p * 100).toFixed(2),
              },
            });
          }
          localStorage.setItem(fileMd5, JSON.stringify(cpt));
        },
        // 设置并发上传的分片数量。
        parallel: 4,
        // 设置分片大小。默认值为1 MB，最小值为100 KB。
        partSize: chunkSize,
        headers,
        // 自定义元数据，通过HeadObject接口可以获取Object的元数据。
        meta: { year: 2020, people: 'test' },
        mime: file.raw ? file.raw.type : file.type,
      };
      try {
        if (localStorage.getItem(fileMd5)) {
          const checkPoint = localStorage.getItem(fileMd5);
          console.log('我走断点续传');
          options.checkpoint = checkPoint;
        }
        const result = await client.multipartUpload(
          filePath,
          file.raw ? file.raw : file,
          {
            ...options,
          }
        );
        const res = result.res;
        localStorage.removeItem(fileMd5);
        if (res.status === 200) {
          let uploadFileUrl = res.requestUrls[0].indexOf('?')
            ? res.requestUrls[0].split('?')[0]
            : res.requestUrls[0];
          // 上传成功ga
          let endUpload = Math.round(
            (new Date().getTime() - beginUpload) / 1000
          );
          resolve({
            code: 200,
            data: {
              file: uploadFileUrl,
              progress: 100,
              gaData: {
                endUpload,
                gafileExtension,
                gafileSize,
                videoFrame,
                videoBitRate,
              },
            },
          });
          client = null;
        }
      } catch (err) {
        console.log(err);
        client = null;
        reject({
          code: cancel ? 'cancel' : 'error',
          data: {
            msg: err,
            gaData: {
              gafileExtension,
              gafileSize,
              videoFrame,
              videoBitRate,
            },
          },
        });
      }
    }
  });
};

// const batchPutImgs = async (file) => {
//   return (
//     new Promise() <
//     any >
//     (async (resolve, reject) => {
//       const info = await getClientData();
//       if (info && !info.type) {
//         return reject(false);
//       }
//       let count = 0;
//       let uploadUrl = [];
//       function singlePut() {
//         let filename = uuidv4(),
//           ext = file[count].file.raw
//             ? file[count].file.raw.name.substring(
//                 file[count].file.raw.name.lastIndexOf('.')
//               )
//             : file[count].file.name.substring(
//                 file[count].file.name.lastIndexOf('.')
//               ),
//           filePath = `/${file_prefix}${filename}${ext}`;
//         let fileUrl = '';
//         uploadGa(file[count].file);
//         fileUploadRequest();
//         async function fileUploadRequest() {
//           try {
//             const headers = {
//               // 指定Object的访问权限。
//               // 'x-oss-object-acl': 'public-read',
//             };
//             const result = await client.put(
//               `/${filePath}`,
//               file[count].file.raw ? file[count].file.raw : file[count].file,
//               { headers }
//             );
//             const res = result.res;
//             if (res?.status == 200) {
//               const uploadFileUrl = res.requestUrls[0];
//               // 上传成功ga
//               let endUpload = Math.round(
//                 (new Date().getTime() - beginUpload) / 1000
//               );
//               let label = `${endUpload}s_${gafileExtension}_${gafileSize}m_${videoFrame}fps_${videoBitRate}kbps`;
//               sentGAEvent({
//                 action: 'oss_upload_video_time',
//                 label,
//               });
//               uploadUrl.push(uploadFileUrl);

//               if (count < file.length - 1) {
//                 count += 1;
//                 singlePut();
//               } else {
//                 // if (isuploadRetry) {
//                 //   uploadcall(true, {
//                 //     uploadFileUrl: uploadUrl,
//                 //     uploadFinished: true,
//                 //     result: true,
//                 //     type: 'putBatch',
//                 //     gaobj: {
//                 //       time: endUpload,
//                 //     },
//                 //   });
//                 // }
//                 resolve({
//                   uploadFileUrl: uploadUrl,
//                   uploadFinished: true,
//                   result: true,
//                   type: 'putBatch',
//                   gaobj: {
//                     time: endUpload,
//                   },
//                 });
//               }
//             }
//           } catch (e) {
//             // if (isuploadRetry) {
//             //   uploadcall(false, {
//             //     result: false,
//             //     type: 'batchPutImgs',
//             //   });
//             // }
//             reject(false);
//             // 上传失败ga
//             let label = `other_${gafileExtension}_${gafileSize}m`;
//             sentGAEvent({
//               action: 'oss_upload_video_fail',
//               label,
//             });
//           }
//         }
//       }
//       singlePut();
//     })
//   );
// };

// 上传Ga相关
let beginUpload, gafileExtension, gafileSize, videoBitRate, videoFrame;
function uploadGa(file) {
  //   const fileStore = uploadFile();
  beginUpload = new Date().getTime();
  gafileExtension = ext;
  gafileSize =
    (file.raw && file.raw.size ? file.raw.size : file.size) / 1024 / 1024 > 1
      ? Math.round((file.raw ? file.raw.size : file.size) / 1024 / 1024)
      : '1';
}

function getNowFormatDate() {
  let date = new Date(),
    year = date.getFullYear(), //获取完整的年份(4位)
    month = date.getMonth() + 1, //获取当前月份(0-11,0代表1月)
    strDate = date.getDate(); // 获取当前日(1-31)
  if (month < 10) month = `0${month}`; // 如果月份是个位数，在前面补0
  if (strDate < 10) strDate = `0${strDate}`; // 如果日是个位数，在前面补0
  return `${year}-${month}-${strDate}`;
}

// 取消上传的方法
export const uploadCancel = () => {
  cancel = true;
};

export const downloadPreSign = async (url) => {
  const formData = new FormData();
  formData.append('preSign-url', url);
  const options = {
    body: formData,
    method: 'POST',
  };

  let data = await request(API_URL + '/downloadPreSign', options);
  return data;
};
